var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilterOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.92857L13 7.92857M13 7.92857C13 8.99369 13.8954 9.85714 15 9.85714C16.1046 9.85714 17 8.99369 17 7.92857C17 6.86345 16.1046 6 15 6C13.8954 6 13 6.86345 13 7.92857ZM9 13.0714L17 13.0714M9 13.0714C9 14.1365 8.10457 15 7 15C5.89543 15 5 14.1365 5 13.0714C5 12.0063 5.89543 11.1429 7 11.1429C8.10457 11.1429 9 12.0063 9 13.0714Z",
    stroke: "#19192A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOption);
export default __webpack_public_path__ + "static/media/icon-filter-option.c9ac4246077d14b3e2d8b654828eeff5.svg";
export { ForwardRef as ReactComponent };